const DEFAULT_THREE_INSULATION_OPTIONS = Object.freeze({
  wall: Object.freeze({
    enabled: true,
    opacity: 0.56
  }),
  ceiling: Object.freeze({
    enabled: false,
    thickness: 80,
    opacity: 0.34
  })
});

function clampNumber(value, min, max, fallback) {
  const numericValue = Number(value);
  const number = Number.isFinite(numericValue) ? numericValue : fallback;
  return Math.max(min, Math.min(max, number));
}

function normalizeOptions(value = {}) {
  const wall = value?.wall && typeof value.wall === 'object' ? value.wall : {};
  const ceiling = value?.ceiling && typeof value.ceiling === 'object' ? value.ceiling : {};
  return {
    wall: {
      enabled: wall.enabled !== false,
      opacity: clampNumber(wall.opacity, 0.18, 0.85, DEFAULT_THREE_INSULATION_OPTIONS.wall.opacity)
    },
    ceiling: {
      enabled: ceiling.enabled === true,
      thickness: clampNumber(ceiling.thickness, 20, 400, DEFAULT_THREE_INSULATION_OPTIONS.ceiling.thickness),
      opacity: clampNumber(ceiling.opacity, 0.18, 0.8, DEFAULT_THREE_INSULATION_OPTIONS.ceiling.opacity)
    }
  };
}

export {
  DEFAULT_THREE_INSULATION_OPTIONS,
  clampNumber,
  normalizeOptions
};
